import { AppStateService } from '@core/data/services';
import { Messenger } from '@shared/data/messaging';

export class TenantStateHandler {
  public initialize(appStateService: AppStateService, messenger: Messenger): void {
    
  }
}
